module.exports = window.React || {Component: {}};


/*****************
 ** WEBPACK FOOTER
 ** external "window.React || {Component: {}}"
 ** module id = 3
 ** module chunks = 0 1 2
 **/